<template>
  <v-dialog v-model="activo" max-width="500" persistent>
    <v-card>
      <!-- Header -->
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon color="white" left>fa-question-circle</v-icon>
        <span style="font-size:16px; font-weight:600">Tutorial — Becas Externas</span>
        <v-spacer />
        <span class="text-caption white--text">{{ paso + 1 }} / {{ pasos.length }}</span>
      </v-card-title>

      <!-- Barra de progreso -->
      <v-progress-linear
        :value="((paso + 1) / pasos.length) * 100"
        color="primary"
        height="4"
      />

      <v-card-text class="pt-4 pb-2 px-4">

        <!-- ILUSTRACION POR PASO -->
        <div class="tour-ilustracion mb-4" :style="{ borderColor: colorActual }">

          <!-- PASO 1: Columna Activo -->
          <div v-if="paso === 0">
            <table class="tour-tabla">
              <thead>
                <tr>
                  <th>Carnet</th>
                  <th>Nombre</th>
                  <th style="text-align:center" class="tour-th--highlight">Activo</th>
                  <th>Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0101-AA-001</td>
                  <td>Juan Perez</td>
                  <td style="text-align:center">
                    <v-chip x-small color="success" dark>Activo</v-chip>
                  </td>
                  <td>...</td>
                </tr>
                <tr>
                  <td>0202-BB-002</td>
                  <td>Maria Lopez</td>
                  <td style="text-align:center">
                    <v-chip x-small color="error" dark>Inactivo</v-chip>
                  </td>
                  <td>...</td>
                </tr>
              </tbody>
            </table>
            <div class="tour-etiqueta success--text">
              <v-icon small color="success">fa-arrow-up</v-icon>
              Nueva columna con estado del becario
            </div>
          </div>

          <!-- PASO 2: Columna Fecha Retiro -->
          <div v-else-if="paso === 1">
            <table class="tour-tabla">
              <thead>
                <tr>
                  <th>Activo</th>
                  <th class="tour-th--highlight">Fecha Retiro</th>
                  <th>Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-chip x-small color="success" dark>Activo</v-chip></td>
                  <td style="color:#aaa; font-size:11px">—</td>
                  <td>...</td>
                </tr>
                <tr>
                  <td><v-chip x-small color="error" dark>Inactivo</v-chip></td>
                  <td style="color:#c62828; font-size:11px">10/04/2026 09:15</td>
                  <td>...</td>
                </tr>
              </tbody>
            </table>
            <div class="tour-etiqueta error--text">
              <v-icon small color="error">fa-arrow-up</v-icon>
              Fecha en que fue desactivado el becario
            </div>
          </div>

          <!-- PASO 3: Boton Desactivar -->
          <div v-else-if="paso === 2">
            <table class="tour-tabla">
              <thead>
                <tr>
                  <th>Activo</th>
                  <th style="text-align:right">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-chip x-small color="success" dark>Activo</v-chip></td>
                  <td style="text-align:right">
                    <v-btn text x-small fab color="amber darken-3">
                      <v-icon x-small>fa-pen</v-icon>
                    </v-btn>
                    <v-btn text x-small fab color="orange darken-3" class="tour-btn-pulsing">
                      <v-icon x-small>fa-ban</v-icon>
                    </v-btn>
                    <v-btn text x-small fab color="primary">
                      <v-icon x-small>fa-trash-alt</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="tour-etiqueta orange--text text--darken-3">
              <v-icon small color="orange darken-3">fa-arrow-up</v-icon>
              Boton desactivar — visible solo cuando el becario esta activo
            </div>
          </div>

          <!-- PASO 4: Boton Reactivar -->
          <div v-else-if="paso === 3">
            <table class="tour-tabla">
              <thead>
                <tr>
                  <th>Activo</th>
                  <th style="text-align:right">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-chip x-small color="error" dark>Inactivo</v-chip></td>
                  <td style="text-align:right">
                    <v-btn text x-small fab color="amber darken-3">
                      <v-icon x-small>fa-pen</v-icon>
                    </v-btn>
                    <v-btn text x-small fab color="success" class="tour-btn-pulsing">
                      <v-icon x-small>fa-check-circle</v-icon>
                    </v-btn>
                    <v-btn text x-small fab color="primary">
                      <v-icon x-small>fa-trash-alt</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="tour-etiqueta success--text">
              <v-icon small color="success">fa-arrow-up</v-icon>
              Boton reactivar — visible solo cuando el becario esta inactivo
            </div>
          </div>

        </div>

        <!-- Titulo del paso -->
        <div class="d-flex align-center mb-2">
          <v-chip small :color="pasoActual.color" dark class="mr-2">
            <v-icon x-small left>{{ pasoActual.icono }}</v-icon>
            Paso {{ paso + 1 }}
          </v-chip>
          <span style="font-size:15px; font-weight:600">{{ pasoActual.titulo }}</span>
        </div>

        <!-- Descripcion -->
        <p style="font-size:14px; color:#444; line-height:1.6" class="mb-2">
          {{ pasoActual.descripcion }}
        </p>

        <!-- Puntos de navegacion -->
        <div class="d-flex justify-center mt-3 mb-1">
          <div
            v-for="(p, i) in pasos"
            :key="i"
            class="tour-punto mx-1"
            :class="{ 'tour-punto--activo': i === paso }"
            :style="i === paso ? { background: colorActual } : {}"
            @click="paso = i"
          />
        </div>

      </v-card-text>

      <v-card-actions class="px-4 pb-3">
        <v-btn text small color="grey darken-1" :disabled="paso === 0" @click="paso--">
          <v-icon small left>fa-chevron-left</v-icon>Anterior
        </v-btn>
        <v-spacer />
        <v-btn text small color="error" @click="$emit('cerrar')">Salir</v-btn>
        <v-btn v-if="paso < pasos.length - 1" small color="primary" depressed @click="paso++">
          Siguiente<v-icon small right>fa-chevron-right</v-icon>
        </v-btn>
        <v-btn v-else small color="success" depressed @click="$emit('cerrar')">
          <v-icon small left>fa-check</v-icon>Finalizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TourBecasExternas',
  props: {
    activo: { type: Boolean, default: false }
  },
  data: () => ({
    paso: 0,
    pasos: [
      {
        titulo: 'Columna Activo',
        icono: 'fa-toggle-on',
        color: 'success',
        descripcion: 'La tabla ahora muestra el estado de cada becario externo. El chip verde indica que el becario esta Activo; el chip rojo indica que esta Inactivo.'
      },
      {
        titulo: 'Columna Fecha Retiro',
        icono: 'fa-calendar-times',
        color: 'error',
        descripcion: 'Cuando un becario es desactivado, se guarda automaticamente la fecha y hora de retiro. Si el becario esta activo, la columna aparece vacia.'
      },
      {
        titulo: 'Boton Desactivar',
        icono: 'fa-ban',
        color: 'orange darken-3',
        descripcion: 'El boton naranja con el icono fa-ban aparece en Opciones cuando el becario esta Activo. Al confirmar, se marca como Inactivo y se registra la Fecha de Retiro.'
      },
      {
        titulo: 'Boton Reactivar',
        icono: 'fa-check-circle',
        color: 'success',
        descripcion: 'El boton verde con el icono fa-check-circle aparece cuando el becario esta Inactivo. Al hacer clic se reactiva de inmediato y se borra la Fecha de Retiro.'
      }
    ]
  }),

  computed: {
    pasoActual() {
      return this.pasos[this.paso]
    },
    colorActual() {
      const mapa = {
        'success': '#2e7d32',
        'error': '#c62828',
        'orange darken-3': '#e65100',
        'primary': '#1565c0'
      }
      return mapa[this.pasoActual.color] || '#1565c0'
    }
  },

  watch: {
    activo(val) {
      if (val) this.paso = 0
    }
  }
}
</script>

<style scoped>
.tour-ilustracion {
  border: 2px solid;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}
.tour-etiqueta {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.tour-th--highlight {
  background: #fff9c4 !important;
  font-weight: 700;
}
.tour-punto {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: all 0.2s;
}
.tour-punto--activo {
  width: 22px;
  border-radius: 5px;
}
.tour-btn-pulsing {
  animation: tour-pulse 1.2s ease-in-out infinite;
}
@keyframes tour-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(0,0,0,0.25); }
  70%  { box-shadow: 0 0 0 6px rgba(0,0,0,0); }
  100% { box-shadow: 0 0 0 0 rgba(0,0,0,0); }
}
</style>

<style>
.tour-tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.tour-tabla th,
.tour-tabla td {
  border: 1px solid #e0e0e0;
  padding: 4px 8px;
}
.tour-tabla th {
  background: #e3f2fd;
  font-weight: 600;
}
</style>
